import React, {FC, useEffect} from 'react';
import {Flex, Title, Text} from '@priority-software/priority-style-react';
import CompletedImage from '../../../../../images/EOY-Completed-image.svg';
import styles from './FinishedStep.module.scss';
import texts from '../../../texts';
import {useFooterContext} from '../../../hooks';
import {NextState} from '../../../types';

export const FinishedStep: FC = () => {
    const footerState = useFooterContext();

    useEffect(() => {
        if (footerState.onNextState === NextState.Processing) {
            footerState.setOnNextState(NextState.Done);
        }
    }, [footerState.onNextState]);

    return (
        <Flex
            componentClasses={styles.wrapper}
            direction={'column'}
            alignItems={'center'}
            justifyContent={'center'}
        >
            <img alt={''} src={CompletedImage} />
            <Title skin={'h2'} textColor={'primary-700'} componentClasses={styles.title}>
                {texts['stage2_step2_title']}
            </Title>
            <Text skin={'paragraph-1'} textColor={'primary-700'} tag={'span'}>
                {texts['stage2_step2_prompt']}
            </Text>
        </Flex>
    );
};
